import React from'react';import CheckoutContext from"../providers/CheckoutProvider.context";import AddressBookContext from"../providers/AddressBookProvider.context";/**
 * Returns the value of the checkout provider state.
 * @returns {Object}
 */export var useCheckoutContext=function useCheckoutContext(){return React.useContext(CheckoutContext);};/**
 * Returns the value of address book provider state.
 * @returns {Object}
 */export var useAddressBook=function useAddressBook(){return React.useContext(AddressBookContext);};